<template>
  <div class="md-layout page-feedback">
    <div class="md-layout-item md-size-100">
      <md-card class="md-card-contact">
        <md-card-header class="md-card-header-primary text-center">
          <h4 class="title" style="color:white">
            {{ $t("Review Comment") }}
          </h4>
        </md-card-header>
        <md-card-content>
          <md-button
            class="md-primary"
            style="width:200px; margin-bottom: 20px;"
            @click="goBack"
            >Go Back</md-button
          >
          <div class="md-layout-item md-size-40 md-small-size-100">
            <label>{{ $t("Flight Review Status:") }} </label>
            <md-radio
              :disabled="!isEventStatuEditable"
              v-model="eventStatus"
              :value="1"
              >{{ $t("Pass") }}</md-radio
            >
            <md-radio
              :disabled="!isEventStatuEditable"
              v-model="eventStatus"
              :value="2"
              >{{ $t("Fail") }}</md-radio
            >
          </div>
          <div class="md-layout-item md-size-40 md-small-size-100">
            <validated-text-input prefix="FR" :placeholder="$t('Flight Review No')" :name="$t('Flight Review No')" v-model="flight_review_no" validation-rules="required|digits:10" />
          </div>
          <div class="md-layout-item md-size-100 md-small-size-100">
            <md-field>
              <label>{{ $t("Your Comment") }}</label>
              <md-textarea v-model="description"></md-textarea>
            </md-field>
          </div>
        </md-card-content>
        <md-card-actions>
          <md-button
            :disabled="loading"
            class="md-primary"
            @click="sendFeedback"
            >{{ $t("Submit") }}</md-button
          >
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";
import { updateBookingStatus } from "@/services/flightReview.service.js";
import ValidatedTextInput from "@/components/Inputs/ValidatedTextInput.vue";


export default {
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      description: "",
      flight_review_no: "",
      eventStatus: undefined,
      isEventStatuEditable: true,
      loading: false
    };
  },
  components: {
    ValidatedTextInput
  },
  mounted() {
    const { eventStatus, description, flight_review_no } = this.$route.query;
    if (+eventStatus !== 0) {
      this.isEventStatuEditable = false;
    }
    this.eventStatus = +eventStatus;
    this.description = description;
    this.flight_review_no = flight_review_no
  },
  methods: {
    async sendFeedback() {
      if ([1, 2].indexOf(this.eventStatus) === -1) {
        this.$notify({
          message: this.$t("Please select a flight review status"),
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "warning",
          timeout: 3000
        });
        return;
      }

      const res = await this.$validator.validateAll()
      if(!res) return

      if (this.loading) return;

      const _self = this;
      swal
        .fire({
          text: this.$t("Do you want to submit now?"),
          showCancelButton: true,
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          confirmButtonText: this.$t("Yes"),
          cancelButtonText: this.$t("Cancel"),
          buttonsStyling: false
        })
        .then(async function({ value }) {
          if (!value) return;
          _self.loading = true;
          try {
            const { id } = _self.$route.query;
            await updateBookingStatus({
              id,
              event_status: _self.eventStatus,
              flight_review_no: 'FR' + _self.flight_review_no,
              description: _self.description
            });
            _self.loading = false;
            _self.$router.replace("/flight-review/reviewerBookingList");
          } catch {
            _self.loading = false;
          }
        });
    },
    goBack() {
      this.$router.back(-1);
    }
  }
};
</script>

<style lang="scss">
.page-feedback {
  .md-disabled .md-checkbox-label,
  .md-disabled .md-checkbox-container,
  .md-checked.md-disabled .md-checkbox-container,
  .md-radio.md-disabled .md-radio-label,
  .md-radio.md-disabled .md-radio-container {
    opacity: 0.7;
    cursor: not-allowed;
  }
}
</style>
